'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

var defaultLocaleQuery = graphqlTag.gql`
  query GetDefaultLocale($retailerMoniker: String!) {
    globalSettings(product: "global", retailerMoniker: $retailerMoniker) {
      defaultLanguage
      defaultCountry
    }
  }
`;

exports["default"] = defaultLocaleQuery;
